import { render, staticRenderFns } from "./ProjectsInProcess.vue?vue&type=template&id=27384e32&"
import script from "./ProjectsInProcess.vue?vue&type=script&lang=js&"
export * from "./ProjectsInProcess.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsInProcess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports